import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Row, Col, message, Typography } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

const TeamForm = ({ formData = {}, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);

  useEffect(() => {
    if (formData && formData.id) {
      form.setFieldsValue(formData);
      if (formData.image) {
        setFileList([
          {
            uid: "-1",
            name: "Existing Image",
            status: "done",
            url: `http://93.127.203.113:5005${formData.image}`,
          },
        ]);
      }
    } else {
      form.resetFields(); // Reset form when adding a new team member
      setFileList([]); // Ensure file list is cleared
    }
  }, [formData]);

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
  };

  const beforeUpload = (file) => {
    setFileList([file]); // Keep only one file
    return false; // Prevent auto-upload
  };

  const onFinish = async (values) => {
    const payload = new FormData();

    Object.keys(values).forEach((key) => {
      payload.append(key, values[key]);
    });

    if (fileList.length > 0 && fileList[0].originFileObj) {
      payload.append("image", fileList[0].originFileObj); // Correct field name
    }

    try {
      if (formData?.id) {
        await axios.put(`http://93.127.203.113:5005/team/${formData.id}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Team member updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/team", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Team member created successfully");
      }
      refetchData();
      closeModal();
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save team member.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData?.id ? "Edit Team Member" : "Add Team Member"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter name" }]}>
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Job" name="job" rules={[{ required: true, message: "Please enter job title" }]}>
              <Input placeholder="Enter job title" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Upload Image">
              <Upload
                listType="picture"
                maxCount={1}
                fileList={fileList}
                beforeUpload={beforeUpload}
                onChange={handleFileChange}
                onRemove={() => setFileList([])}
              >
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
            Save
          </Button>
          <Button
            type="default"
            onClick={() => {
              closeModal();
              form.resetFields();
              setFileList([]);
            }}
            style={{ marginLeft: "10px" }}
          >
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TeamForm;
